import type { Variant } from '@scayle/storefront-nuxt'
import {
  getAttributeValue,
  getAttributeValueTuples,
  getFirstAttributeValue,
} from '@scayle/storefront-nuxt'

/**
 * Get Date from product variant restockDate attribute
 *
 * @param {string} restockDateAttribute format DDMMYY
 * @return {Date|undefined}
 */
export const restockDateAttribute2Date = (
  restockDateAttribute?: string,
): Date | undefined => {
  if (!restockDateAttribute || restockDateAttribute.length !== 6) return

  const [dd, mm, yy] = restockDateAttribute.match(/.{2}/g)!
  const parsedDateTime = Date.parse(`20${yy}-${mm}-${dd}`)

  return isNaN(parsedDateTime) ? undefined : new Date(parsedDateTime)
}

/**
 * Get restock date for given product variant
 *
 * @param {Variant} variant
 * @return {Date|undefined}
 */
export const getRestockDate = (variant?: Variant): Date | undefined => {
  const restockDateAttribute: string | undefined = getFirstAttributeValue(
    variant?.attributes,
    'restockDate',
  )?.value

  return restockDateAttribute2Date(restockDateAttribute)
}

export default {
  getAttributeValue,
  getAttributeValueTuples,
  getFirstAttributeValue,
}
